import {
  REQUEST_SET_PROVISIONAL_CLAIM_DETAILS,
  RESET_PROVISIONAL_CLAIM_DETAILS_STORE,
  SET_PROVISIONAL_CLAIM_REFERENCE,
  SET_UPDATE_CLAIM_NUMBER_RESULT,
} from 'containers/ProvisionalClaimRecap/constants';
import { fromJS } from 'immutable';

const initState = fromJS({
  provisionalClaimDetails: {},
  provisionalClaimReference: '',
  updateClaimNumberResult: {
    isClaimNumberExist: false,
    isProvisionalClaimUpdated: false,
  },
});

const ProvisionalClaimDetailesReducer = (state = initState, action: any) => {
  switch (action.type) {
    case REQUEST_SET_PROVISIONAL_CLAIM_DETAILS:
      return state.set('provisionalClaimDetails', fromJS(action.payload));
    case RESET_PROVISIONAL_CLAIM_DETAILS_STORE:
      return initState;
    case SET_PROVISIONAL_CLAIM_REFERENCE:
      return state.set('provisionalClaimReference', action.reference);
    case SET_UPDATE_CLAIM_NUMBER_RESULT:
      return state.set('updateClaimNumberResult', fromJS(action.result));
    default:
      return state;
  }
};
export default ProvisionalClaimDetailesReducer;
